// extracted by mini-css-extract-plugin
export default {"container":"qcGYq","divider":"tKbuK"};